/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Terms_Title1Inputs */

const en_coinvestments_terms_title1 = /** @type {(inputs: Coinvestments_Terms_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Coinvestments_Terms_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_terms_title1 = /** @type {((inputs?: Coinvestments_Terms_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Terms_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_terms_title1(inputs)
});
export { coinvestments_terms_title1 as "coInvestments_terms_title" }